import { render, staticRenderFns } from "./decorate.vue?vue&type=template&id=4f135b8c&"
import script from "./decorate.vue?vue&type=script&lang=js&"
export * from "./decorate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports